{
  "dismiss": "Odstranit"
}